/**
 * Translations.
 */
export default {
  ACTION: {
    MESSAGE_DETAILS: 'Detalhes da mensagem',
    OK: 'OK'
  },
  ERROR: {
    ERROR: 'Erro',
    FETCH_DATA: 'Obter dados',
    NO_ORDER: 'Não foi possível sortear encomenda'
  },
  HEADER: {
    DATE: 'Data',
    MESSAGE: 'Mensagem',
    NAME: 'Nome Cliente',
    ORDER_CODE: 'Código Encomenda',
    ORDER_DATE: 'Data de encomenda',
    ORDER_ID: 'Encomenda',
    ORDER_VALUE: 'Valor',
    PAYMENT_DATE: 'Data de pagamento',
    PAYMENT_STATE: 'Estado do pagamento',
    PRICE: 'Preço',
    VALUE: 'Valor'
  },
  LABEL: {
    COPIED: 'Copiado!',
    EXPORT: 'Exportar',
    GIVEWAY_DATE: 'Data Sorteio:',
    MONTH: 'Mês',
    ORDER_PRIZE_MSG: 'Encomenda premiada:',
    PAYED: 'Pago',
    PRIZE: 'Giveaway',
    RAFFLE: 'Giveaway',
    UNPAYED: 'Por pagar',
    UNTIL: 'a',
    YEAR: 'Ano'
  },
  SENTENCE: {
    NO_ROWS_ORDER_MESSAGES: 'Sem mensagens',
    NO_ROWS_ORDER_MESSAGES_DESCRIPTION: 'Sem mensagens de clientes (ainda).',
    NO_ROWS_ORDERS: 'Sem encomendas',
    NO_ROWS_ORDERS_DESCRIPTION: 'Sem encomendas (ainda).'
  },
  SUCCESS: {
    SUCCESS: 'Sucesso'
  },
  TOOLTIP: {
    DATE: 'Data',
    ORDER_CODE: 'Código da encomenda',
    ORDER_ID: 'Encomenda',
    PAYMENT_DATE: 'Data de pagamento',
    PAYMENT_STATE: 'Estado do pagamento',
    PRICE: 'Preço',
    VALUE: 'Valor'
  }
};
